import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useCurrent, useFetch } from '../hooks';
import { useParams } from 'react-router-dom';
import DashboradNavBar from '../components/dashborad/DashboradNavBar';
import MonthlyLineChart from '../components/dashborad/MonthlyLineChart';
import { MwSelector } from '../components/ui';

const DashBoard = () => {

    const [t] = useTranslation('global')
    const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
    // let salesCurrentYear = 0;
    const date = new Date();
    const currentMonth = date.getMonth() + 1;
    // const currentYeay = date.getFullYear();
    // const Sales Months groups
    const [serviceSelected, setServiceSelected] = useState();
    const [ratingByService, setRatingByService] = useState([]);
    const [ratingByServiceLoading, setRatingByServiceLoading] = useState(true);
    const tenantUsername = useParams()?.tenant;
    const [servicesCount, setServicesCount] = useState(0);
    const [servicesRate, setServicesRate] = useState(0);
    const [employeesRate, setEmployeesRate] = useState(0);
    const [ratingsCount, setRatingsCount] = useState(0);
    const [completedComplaintsCount, setCompletedComplaintsCount] = useState(0);
    const [incompleteComplaintsCount, setIncompleteComplaintsCount] = useState(0);

    const servicesUrl = useMemo(() => {
        if (!currentTenantId || !currentCompanyId || !currentBranchId) return null;
        return `${process.env.REACT_APP_RATING_API_BASE_URL}/services/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
    }, [currentTenantId, currentCompanyId, currentBranchId]);
    const ratingUrl = useMemo(() => {
        const selectedServiceId = serviceSelected?.value?._id || serviceSelected?._id;
        if (!currentTenantId || !currentCompanyId || !currentBranchId || !selectedServiceId) return null;
        return `${process.env.REACT_APP_RATING_API_BASE_URL}/${currentTenantId}/${currentCompanyId}/${currentBranchId}/${selectedServiceId}`;
    }, [currentTenantId, currentCompanyId, currentBranchId, serviceSelected]);
    const dashboardStatsUrl = useMemo(() => {
        if (!currentTenantId || !currentCompanyId || !currentBranchId) return null;
        return `${process.env.REACT_APP_RATING_API_BASE_URL}/dashboard/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
    }, [currentTenantId, currentCompanyId, currentBranchId]);

    const { data: servicesResult, loading: servicesLoading } = useFetch(servicesUrl, Boolean(servicesUrl));
    const { data: ratingResult, loading: ratingLoading, fetchData } = useFetch(ratingUrl, false);
    const { data: dashboardStatsResult, loading: dashboardStatsLoading } = useFetch(dashboardStatsUrl, Boolean(dashboardStatsUrl));


    const ratingByServiceHandler = async () => {
        // const res = await axios.get(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/invoices/month-group/${currentTenantId}/${currentCompanyId}/${currentBranchId}/${currentYeay}`);
        // const sum = res.data;
        setRatingByService([
            // "3",
            // "4",
            // "4",
            // "5",
            // "2",
            // "5",
            // "5",
            // "5",
            // "4",
            // "5",
            // "5",
            // "5",
        ])
        setRatingByServiceLoading(false)
    }


    useEffect(() => {
        ratingByServiceHandler();
    }, []);

    useEffect(() => {
        if ((servicesResult?.data?.length || 0) > 0) {
            let _rand = Math.round(Math.random() * (servicesResult?.data?.length - 0) + 0);
            if (_rand >= servicesResult?.data?.length) {
                _rand = _rand - 1;
            }
            console.log('_rand', _rand);
            const _selected = servicesResult?.data[_rand]
            setServiceSelected({ label: _selected?.serviceName, value: _selected });
            console.log('servicesResult => ', servicesResult);
        }
    }, [servicesResult]);

    useEffect(() => {
        if (serviceSelected && ratingUrl) {
            setRatingByServiceLoading(true)
            fetchData();
        }
        console.log('serviceSelected', serviceSelected)
    }, [serviceSelected, ratingUrl, fetchData]);

    useEffect(() => {
        if (servicesResult?.data && ratingResult?.data) {
            console.log('ratingResult => ', ratingResult);
            let _monthlyRating = [];

            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].forEach(month => {
                let sumMonthly = 0;
                ratingResult.data.forEach(res => {
                    const _date = new Date(res.createdAt);
                    if (_date.getMonth() + 1 === month) {
                        if (res.ratingService) {
                            sumMonthly += parseInt(res.ratingService || 0)
                        }
                    }
                })
                _monthlyRating.push(sumMonthly)
            })
            console.log('_monthlyRating => ', _monthlyRating)
            setRatingByService(_monthlyRating)
            setRatingByServiceLoading(false)

        }
    }, [ratingResult, servicesResult]);

    useEffect(() => {
        if (!servicesLoading && !ratingLoading && !ratingResult?.data) {
            setRatingByService([])
            setRatingByServiceLoading(false)
        }
    }, [servicesLoading, ratingLoading, ratingResult]);

    useEffect(() => {
        if (dashboardStatsResult?.data) {
            setServicesCount(dashboardStatsResult.data.servicesCount || 0);
            setRatingsCount(dashboardStatsResult.data.ratingsCount || 0);
            setCompletedComplaintsCount(dashboardStatsResult.data.completedComplaintsCount || 0);
            setIncompleteComplaintsCount(dashboardStatsResult.data.incompleteComplaintsCount || 0);
            setServicesRate(dashboardStatsResult.data.servicesRate || 0);
            setEmployeesRate(dashboardStatsResult.data.employeesRate || 0);
        }
    }, [dashboardStatsResult]);

    return (
        <div className='flex flex-col gap-6 p-4 h-full overflow-y-auto bg-slate-50/50'>
            <div className='flex justify-between items-center'>
                <h1 className='text-2xl font-bold text-slate-800'>{t('menu.Dashboard')}</h1>
            </div>

            {
                servicesResult && dashboardStatsResult &&
                <DashboradNavBar
                    servicesLoading={dashboardStatsLoading}
                    serviceLength={servicesCount}
                    ratingLoading={dashboardStatsLoading}
                    ratingLength={ratingsCount}
                    completedComplaintsCount={completedComplaintsCount}
                    incompleteComplaintsCount={incompleteComplaintsCount}
                    servicesRate={servicesRate}
                    employeesRate={employeesRate}
                />
            }

            <div className='bg-white p-6 rounded-2xl shadow-sm border border-slate-100'>
                <div className='flex flex-wrap justify-between items-center mb-6 gap-4'>
                    <h2 className='text-lg font-bold text-slate-700'>{t('dashboard.monthlyRatings')}</h2>
                    {serviceSelected && (
                        <div className='w-full sm:w-64'>
                            <MwSelector
                                initalValue={serviceSelected?.serviceName || t('reports.selectServicePlaceholder')}
                                dataType={'labelValue'}
                                withAddNew={false}
                                setSelectedItem={setServiceSelected}
                                selectedItem={serviceSelected}
                                _data={servicesResult?.data?.map(service => ({
                                    label: service?.serviceName,
                                    value: service,
                                }))}
                            />
                        </div>
                    )}
                </div>
                
                <div className='h-[400px] w-full'>
                    <MonthlyLineChart
                        tenantUsername={tenantUsername}
                        servicesLoading={servicesLoading}
                        servicesResult={servicesResult}
                        serviceSelected={serviceSelected?.value ? serviceSelected?.value : serviceSelected}
                        ratingByService={ratingByService}
                        ratingByServiceLoading={ratingByServiceLoading}
                    />
                </div>
            </div>
        </div>
    )
}

export default DashBoard
